import * as routes from 'constants/apiRoutes'
import generateUrl from 'network/generate-url'

const creditCheckApiRoutes = {
  getCustomerInformation: (guid: string): string => {
    const params = { creditCheckGuid: guid }
    return generateUrl<{ creditCheckGuid: string }>(routes.getCustomerInformation, params)
  },
  postCreditCheckForm: (): string => {
    return generateUrl<null>(routes.submitCreditCheck, null)
  }
}

export default creditCheckApiRoutes



// WEBPACK FOOTER //
// ./src/typings/api-routes/CreditCheckApiRoutes.ts